import { takeEvery } from 'redux-saga/effects';

import { remove } from 'store/modules/listing/customPrices';

import * as customPrices from './utils';

export default function* listenRemove() {
  yield takeEvery(remove.toString(), customPrices.remove);
}
